import { Address } from '@grubhubprod/order-taking-client-sdk/src/sdk/types/geocode';
import React, { useRef, useState } from 'react';
import {
  Button,
  Flex,
  Heading,
  Square,
  Stack,
  SvgX,
} from '@grubhubprod/gh-cookbook-react';
import { Modal } from 'src/components/Modal/Modal';
import { ILocation } from 'src/types/Location';
import {
  EnterpriseLocationForm,
  ILocationFormState,
} from 'src/components/enterprise/features/Locations/ManageLocation/LocationForm';

export interface IEnterpriseLocationFormModalProps {
  locationId?: string;
  corpId: string;
  closeModal: () => void;
  onSuccess: () => void;
  existingFormData?: ILocation;
  onConfirmAddressCb?: (
    fields: ILocation,
    uniqueSuggestedGeoAddresses: Address[]
  ) => void;
  wasAddressConfirmed?: boolean;
}

export function EnterpriseLocationModal({
  locationId,
  corpId,
  closeModal,
  onSuccess,
  existingFormData,
  onConfirmAddressCb,
  wasAddressConfirmed,
}: IEnterpriseLocationFormModalProps): JSX.Element {
  const form = useRef(null);
  const [formState, setFormState] = useState<ILocationFormState>({
    isValid: false,
    isSubmitting: false,
  });
  const isEditing = !!locationId;

  function formStateCb({ isValid, isSubmitting }): void {
    setFormState({ isValid, isSubmitting });
  }
  return (
    <Modal size="sm">
      <Square as="header" dimension="2" width="100%">
        <Button variant="tertiary" type="button" onClick={closeModal}>
          <SvgX size="24px" />
        </Button>
        <Square inset="md">
          <Heading variant="h1">
            {isEditing ? 'Edit location' : 'Add new location'}
          </Heading>
        </Square>
      </Square>
      <Square inset="md">
        <EnterpriseLocationForm
          ref={form}
          corpId={corpId}
          locationId={locationId}
          existingFormData={existingFormData}
          onConfirmAddressCb={onConfirmAddressCb}
          onSuccess={onSuccess}
          formStateCb={formStateCb}
        />
      </Square>
      <Square as="footer" dimension="2" inset="md">
        <Flex>
          <Stack x="x-sm" data-testid="add-button-wrapper">
            <Button
              isLoading={formState.isSubmitting}
              variant="primary"
              buttonSize="medium"
              disabled={!formState.isValid || formState.isSubmitting}
              onClick={() => form.current.submit(wasAddressConfirmed)}
            >
              {isEditing ? 'Update' : 'Add'}
            </Button>
          </Stack>
          <Button
            variant="secondary"
            buttonSize="medium"
            disabled={formState.isSubmitting}
            onClick={closeModal}
          >
            Cancel
          </Button>
        </Flex>
      </Square>
    </Modal>
  );
}
